var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@patternfly/react-styles';
import styles from '../../@patternfly/patternfly-next/components/Card/card.css.js';
import { componentShape } from '../../internal/componentShape';

var propTypes = {
  /** content rendered inside the Card */
  children: PropTypes.any,
  /** additional classes added to the Card */
  className: PropTypes.string,
  /** Sets the base component to render. defaults to article */
  component: componentShape
};

var defaultProps = {
  children: null,
  className: '',
  component: 'article'
};

var Card = function Card(_ref) {
  var children = _ref.children,
      className = _ref.className,
      Component = _ref.component,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'component']);

  return React.createElement(
    Component,
    _extends({ className: css(styles.card, className) }, props),
    children
  );
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

export default Card;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Card/Card.js
// module id = 221
// module chunks = 0